import type { Localizations, LocalizationsProvider } from "~/service/l10n";
import { theme_ns } from "./theme";

const translations = {
    'en-US': {
        'campaign-offers.valid': 'Valid',
        'email-address': 'Email address',
        'event-stream-community': 'News',
        'event-stream-event': 'Events',
        'event-tag-event': 'Event',
        'event-tag-news': 'News',
        'send-feedback': 'Give feedback',
        'feedback-select-store': 'Choose a store',
        'feedback-target-general': 'I want to give general feedback',
        'feedback-target-store': 'I want to give feedback to specific store',
        'feedback-type-thanks': 'Thanks',
        'feedback-type-suggestion': 'Suggestion',
        'feedback-type-complaint': 'Complaint',
        'feedback-type-other': 'Other',
        'fob-all': 'All stores',
        offers: 'Offers',
        'offers-all': 'Show all',
        lowestPrice30: '30 day lowest price',
        'offers-and-services': 'Offers and Services',
        'offers-show-more': 'Show all offers',
        'offers-stream-basic': 'Offers',
        'offers-stream-whats-new': "What's new",
        'offers.valid': 'Valid',
        'open-map': 'Open map',
        'opening-hours': 'Opening hours',
        'opening-hours-exceptional': 'Exceptional opening hours',
        'opening-status-by_appoinment': 'By appoinment',
        'opening-status-closed': 'Closed',
        'opening-status-open': 'Open',
        'read-more': 'Read more',
        'read-less': 'Read less',
        search: 'Search…',
        'search-menu': 'Search',
        'search-stores-and-events': 'Search stores and events',
        'show-all': 'Show all',
        'show-on-map': 'Show on map',
        'we-accept': 'We accept',
        close: 'Close',
        menu: 'Menu',
        'news-and-events': 'News and events',
        'new-stores-in-tripla': 'New stores',
        and: 'and',
        'biorex-movies': "Biroex's movies",
        'buy-movie-ticket': 'Buy ticket',
        'biorex-text': 'View movies currently being shown',
        'museum-title': 'The Fame Music Museum happens',
        categories: 'Categories',
        'alphabetical-order': 'Alphabetical order',
        'filter-and-organize': 'Filter and organize',
        'business-opening-hours': 'Business opening hours',
        'floor-map': 'Floor map',
        floor: 'Floor',
        'write-a-search-word': 'Write a search word',
        'show-more': 'Show more',
        'show-more-events': 'Show more events',
        'show-less': 'Show less',
        opening: 'Open',
        'contact-information': 'Contact information',
        'show-store-on-map': 'Open floormap',
        location: 'Location',
        'select-a-subject': 'Select a subject',
        'contact-the-store': 'Contact the store',
        contact: 'Contact',
        name: 'Name',
        send: 'Send',
        'send-email': 'Send email',
        'your-message': 'Your message',
        description: 'Description',
        'cafe-and-restaurants': 'Cafès and restaurants',
        'stores-and-services': 'Stores and services',
        'promotions-and-offers': 'Promotions and offers',
        phone: 'Phone',
        'opening-hours-today': 'Opening hours',
        'home-page': 'Home',
        'all-shops-and-services': 'All shops and services',
        'more-current-topics': 'More current topics',
        'surf-house-events': "Surf house's events",
        'all-floors': 'All floors',
        'lunch-time': 'Lunch time',
        'lunch-list': 'Lunch list',
        'stores-open': 'Stores open',
        'see-tripla-tips-from-here': "See Tripla's tips from here",
        'invalid-email-address': 'Invalid email address',
        'required-field-not-filled': 'Required field not filled',
        'mandatory-information-is-marked-with-an-asterisk':
            'Mandatory information is marked with an asterisk',
        'please-check-that-you-have-filled-in-all-required-fields':
            'Please check that you have filled in all required fields',
        'registry-description': 'Privacy Policy',
        'i-want-to-be-answered': 'I want to be answered',
        'thank-you-for-your-feedback': 'Thank you for your feedback',
        'find-a-lunch-place': 'Find a lunch place',
        all: 'All',
        'all-contact-information': 'All contact information',
        'map-instruction-text': 'Expand the map full screen to make it interactive',
        'map-instruction-button-text': 'Interact with the map',
        'gift-card': 'Gift card',
        'store.status.BY_APPOINTMENT': 'By appointment',
        'store.status.CLOSED': 'Closed',
        'store.status.OPEN': 'Open',
        'store.status.TEMPORARY_CLOSED': 'Temporarily closed',
        'exceptional opening hours': "Exceptional opening hours",
        'on-this-page': "On this page",
        'search-no-result': "Unfortunately, there are no results for this search!",

        'feedback.required_fields_marked_by_star': 'Required fields',
        'feedback.target': 'Target',
        'feedback.choose_shop' : 'Choose a shop',
        'feedback.type_of_feedback' : 'Type of feedback',
        'feedback.message': 'Feedback',
        'feedback.name' : 'Name',
        'feedback.email' : 'Email',
        'feedback.target.general': 'General feedback',
        'feedback.target.store': 'Feedback to a specific company',
        'feedback.type.thanks': 'Thanks',
        'feedback.type.suggestion': 'Suggestion',
        'feedback.type.complaint': 'Complaint',
        'feedback.type.other': 'Other',
        'feedback.rsvp' : 'I would like to receive a reply',
        'feedback.privacy_statement' : 'Privacy policy',
        'feedback.thank_you' : 'Thank you for your feedback',
        'feedback.send': 'Send',
        'feedback.error.check_all_required_fields': 'Please check all required fields are filled',
        'feedback.error.field_required' : 'Field is required',
        'feedback.error.invalid_email_address' : 'Invalid email address',
        'feedback.error.please_choose_a_store' : 'Please choose a store',

        'no-lunch-menus-found-for-today': 'No lunch menus found for today',
        'no-stores-found': 'No stores found',
    },
    'fi-FI': {
        'campaign-offers.valid': 'Voimassa',
        'email-address': 'Sähköpostiosoite',
        'event-stream-community': 'Uutiset',
        'event-stream-event': 'Tapahtumat',
        'event-tag-event': 'Tapahtuma',
        'event-tag-news': 'Uutinen',
        'send-feedback': 'Anna palautetta',
        'feedback-select-store': 'Valitse liike',
        'feedback-target-general': 'Haluan antaa yleistä palautetta',
        'feedback-target-store': 'Haluan antaa palautetta tietylle toimijalle',
        'feedback-type-thanks': 'Kiitos',
        'feedback-type-suggestion': 'Ehdotus',
        'feedback-type-complaint': 'Moite',
        'feedback-type-other': 'Muu',
        'fob-all': 'Kaikki liikkeet',
        offers: 'SUOSITTUJA TUOTTEITA JUURI NYT',
        'biorex-movies': 'Biorexin elokuvat',
        'offers-all': 'Katso kaikki',
        lowestPrice30: '30 päivän alin hinta',
        'offers-and-services': 'Tarjoukset ja palvelut',
        'offers-show-more': 'Näytä kaikki tarjoukset',
        'offers-stream-basic': 'Tarjoukset',
        'offers-stream-whats-new': 'Uutuudet',
        'offers.valid': 'Voimassa',
        'open-map': 'Avaa pohjakartta',
        'opening-hours': 'Aukioloajat',
        'opening-hours-exceptional': 'Poikkeusaukioloajat',
        'opening-status-by_appoinment': 'Sop.muk.',
        'opening-status-closed': 'Suljettu',
        'opening-status-open': 'Avoinna',
        'read-more': 'Lue lisää',
        'read-less': 'Lue vähemmän',
        search: 'Hae…',
        'search-menu': 'Hae',
        'search-stores-and-events': 'Hae liikkeitä ja tapahtumia',
        'show-all': 'Näytä kaikki',
        'show-on-map': 'Näytä kartalla',
        'store.status.BY_APPOINTMENT': 'Sopimuksen mukaan',
        'store.status.CLOSED': 'Suljettu',
        'store.status.OPEN': 'Avoinna',
        'store.status.TEMPORARY_CLOSED': 'Tilapäisesti suljettu',
        'we-accept': 'Meillä käy',
        close: 'Sulje',
        menu: 'Valikko',
        'news-and-events': 'Ajankohtaista',
        'new-stores-in-tripla': 'Uutta Triplassa',
        and: 'ja',
        'buy-movie-ticket': 'Osta liput',
        'biorex-text': 'Katso nyt ohjelmistossa olevat elokuvat',
        'museum-title': 'Musiikkimuseo Famessa tapahtuu',
        categories: 'Kategoria',
        'alphabetical-order': 'Aakkosellinen hakemisto',
        'filter-and-organize': 'Suodata ja järjestä',
        'business-opening-hours': 'Liikekohtaiset aukioloajat',
        'floor-map': 'Pohjakartta',
        floor: 'Kerros',
        'write-a-search-word': 'Kirjoita hakusana',
        'show-more': 'Näytä enemmän',
        'show-more-events': 'Näytä enemmän tapahtumia',
        'show-less': 'Näytä vähemmän',
        opening: 'Avoinna',
        'contact-information': 'Yhteystiedot',
        'show-store-on-map': 'Näytä sijainti pohjakartalla',
        location: 'Sijainti',
        'select-a-subject': 'Valitse viestin aihe',
        'contact-the-store': 'Ota yhteyttä liikkeeseen',
        name: 'Nimi',
        send: 'Lähetä',
        'send-email': 'Lähetä sähköpostiin',
        'your-message': 'Viestisi',
        description: 'Kuvaus',
        contact: 'Ota yhteyttä',
        'cafe-and-restaurants': 'Kahvilat ja ravintolat',
        'stores-and-services': 'Liikkeet ja palvelut',
        'promotions-and-offers': 'Kampanjat ja tarjoukset',
        phone: 'Puhelin',
        'opening-hours-today': 'Aukioloajat',
        'home-page': 'Etusivu',
        'all-shops-and-services': 'Kaikki liikkeet ja palvelut',
        'more-current-topics': 'Lisää ajankohtaisia aiheita',
        'surf-house-events': 'Surf housen tapahtumat',
        'all-floors': 'Kaikki kerrokset',
        'lunch-time': 'Lounas aika',
        'lunch-list': 'Lounaslista',
        'stores-open': 'Liikkeet avoinna',
        'see-tripla-tips-from-here': 'Katso Triplan vinkki kesään tästä',
        'invalid-email-address': 'Sähköpostiosoite ei kelpaa',
        'required-field-not-filled': 'Pakollinen kenttä täyttämättä',
        'mandatory-information-is-marked-with-an-asterisk': 'Pakolliset tiedot on merkitty tähdellä',
        'please-check-that-you-have-filled-in-all-required-fields':
            'Tarkista, että olet täyttänyt kaikki pakolliset kentät',
        'registry-description': 'Rekisteriseloste',
        'i-want-to-be-answered': 'Haluan, että minulle vastataan',
        'thank-you-for-your-feedback': 'Kiitos palautteestasi',
        'find-a-lunch-place': 'Hae lounaspaikkaa',
        all: 'Kaikki',
        'all-contact-information': 'Kaikki yhteystiedot',
        'map-instruction-text': 'Avaa kartta koko näytölle ja interaktiiviseksi',
        'map-instruction-button-text': 'Etsi reitti tai liikkeen paikka',
        'gift-card': 'Lahjakortti',
        'exceptional opening hours': "Poikkeusaukioloajat",
        'on-this-page': "Tällä sivulla",
        'search-no-result': "Haku ei valitettavasti tuottanut tulosta!",

        'feedback.required_fields_marked_by_star': 'Pakolliset tiedot on merkitty tähdellä',
        'feedback.target': 'Kohde',
        'feedback.choose_shop' : 'Valitse liike',
        'feedback.type_of_feedback' : 'Palautteen tyyppi',
        'feedback.message': 'Palaute',
        'feedback.name' : 'Nimesi',
        'feedback.email' : 'Sähköpostiosoitteesi',
        'feedback.target.general': 'Haluan antaa yleistä palautetta',
        'feedback.target.store': 'Haluan antaa palautetta tietylle toimijalle',
        'feedback.type.thanks': 'Kiitos',
        'feedback.type.suggestion': 'Ehdotus',
        'feedback.type.complaint': 'Moite',
        'feedback.type.other': 'Muu',
        'feedback.rsvp' : 'Haluan, että minulle vastataan',
        'feedback.privacy_statement' : 'Rekisteriseloste',
        'feedback.thank_you' : 'Kiitos palautteesta!',
        'feedback.send': 'Lähetä',
        'feedback.error.check_all_required_fields': 'Tarkista, että kaikki pakolliset kentät on täytetty.',
        'feedback.error.field_required' : 'Kenttä on pakollinen',
        'feedback.error.invalid_email_address' : 'Osoite on virheellinen',
        'feedback.error.please_choose_a_store' : 'Tee valinta',

        'no-lunch-menus-found-for-today': 'Ei lounaslistaa tänään',
        'no-stores-found': 'Liikkeitä ei löytynyt',
    },

} as Localizations;

const provider: LocalizationsProvider = {
    namespace: theme_ns,
    localizations: translations,
};

export default provider;
